var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./visor.vue?vue&type=custom&index=0&blockType=html&xmlns%3Av=urn%3Aschemas-microsoft-com%3Avml&xmlns%3Ao=urn%3Aschemas-microsoft-com%3Aoffice%3Aoffice&xmlns%3Aw=urn%3Aschemas-microsoft-com%3Aoffice%3Aword&xmlns%3Am=http%3A%2F%2Fschemas.microsoft.com%2Foffice%2F2004%2F12%2Fomml&xmlns=http%3A%2F%2Fwww.w3.org%2FTR%2FREC-html40"
if (typeof block0 === 'function') block0(component)

export default component.exports